<template>
	<v-container fluid class="mt-0 pt-0">
		<v-row class="px-3" :class="!inEditMode ? 'read-only-class' : ''">
			<v-col cols="3">
				<DatePicker
					:readonly="!inEditMode"
					v-model="subscription.date"
					:dateLabel="'* ' + $t('fields.date')"
					:errorBorder="!subscriptionValidation.date"
				></DatePicker>
			</v-col>
			<v-col cols="3">
				<Dropdown
					:readonly="!inEditMode"
					v-model="subscription.magazine_id"
					:ajax="true"
					data="magazines-only"
					:errorBorder="!subscriptionValidation.magazine_id"
					:label="'* ' + $t('fields.magazine')"
				></Dropdown>
			</v-col>
			<v-col cols="3">
				<InputField
					:disabled="!inEditMode"
					v-model="subscription.title"
					:label="$t('fields.subscriptionTitle')"
				></InputField>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="3" class="d-flex justify-end">
				<v-btn
					v-if="subscription.id == null || subscription.id == 0 || subscription.id == '0'"
					@click="saveClick"
					color="primary"
					class="mr-3"
					>Spremi</v-btn
				>
				<v-btn @click="backClick">Natrag</v-btn>
			</v-col>
		</v-row>
		<v-row class="pa-4" v-if="subscription.date != null && subscription.magazine_id != null">
			<v-col cols="12">
				<v-card flat outlined>
					<v-card-text>
						<v-row>
							<v-col>
								<TheTable
									:additional-filters="subscriptionRecipientsTable.additionalFilters"
									:default-sort="subscriptionRecipientsTable.defaultSort"
									:excel="true"
									:fields="subscriptionRecipientsTable.headers"
									:filter-save-key="'subscription-recipients-filters'"
									:height="subscriptionRecipientsTable.height"
									:total-records="subscriptionRecipientsTable.total"
									@excel="excelExport"
									@headers="selectSubscriptionRecipientsHeaders"
									@reload="reloadSubscriptionRecipientsData"
								>
									<tr
										v-for="(item, key) in subscriptionRecipientsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editSubscriptionRecipientsClick(props.item.id, true)"
									>
										<td
											v-if="
												subscriptionRecipientsTable.selectedHeaders.includes('member_display')
											"
											@click="editSubscriptionRecipientsClick(item.id, false)"
										>
											{{ item.member_display }}
										</td>
										<td
											v-if="
												subscriptionRecipientsTable.selectedHeaders.includes('delivery_type_id')
											"
											@click="editSubscriptionRecipientsClick(item.id, false)"
										>
											{{ item.delivery_type_display }}
										</td>
										<td
											v-if="subscriptionRecipientsTable.selectedHeaders.includes('branch_name')"
											@click="editSubscriptionRecipientsClick(item.id, false)"
										>
											{{ item.branch_name }}
										</td>
										<td
											v-if="subscriptionRecipientsTable.selectedHeaders.includes('country')"
											@click="editSubscriptionRecipientsClick(item.id, false)"
										>
											{{ item.country }}
										</td>
										<td
											v-if="subscriptionRecipientsTable.selectedHeaders.includes('city')"
											@click="editSubscriptionRecipientsClick(item.id, false)"
										>
											{{ item.city }}
										</td>
										<td
											v-if="subscriptionRecipientsTable.selectedHeaders.includes('address')"
											@click="editSubscriptionRecipientsClick(item.id, false)"
										>
											{{ item.address }}
										</td>
										<td
											v-if="subscriptionRecipientsTable.selectedHeaders.includes('zipcode')"
											@click="editSubscriptionRecipientsClick(item.id, false)"
										>
											{{ item.zipcode }}
										</td>
										<td
											:style="subscription.id == 0 ? 'cursor:default' : ''"
											v-if="subscriptionRecipientsTable.selectedHeaders.includes('collected')"
											@click="toggleCollected(item)"
										>
											<v-icon v-if="item.collected == 1" color="primary">fas fa-square-check</v-icon>
											<v-icon v-else :color="subscription.id == 0 ? 'rgb(225, 225, 225)' : ''">far fa-square</v-icon>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Dropdown from '../../trinkets/Dropdown';
import InputField from '../../trinkets/InputField';
import Subscription from '../../../models/Subscription';
import DatePicker from '@/components/trinkets/DatePicker';
export default {
	name: 'Subscription',
	components: { Dropdown, DatePicker, TheTable, InputField },
	data: function () {
		return {
			inEditMode: false,
			subscription: new Subscription({ id: this.$route.params.id }),
			subscriptionValidation: new Subscription({}, true),
			subscriptionRecipientsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.member'),
						value: 'member_display',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.delivery'),
						value: 'delivery_type_id',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.branch'),
						value: 'branch_name',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.country'),
						value: 'country',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{ text: this.$t('fields.city'), value: 'city', type: '', allowFilter: false, sortable: false },
					{
						text: this.$t('fields.address'),
						value: 'address',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.zipCode'),
						value: 'zipcode',
						type: '',
						allowFilter: false,
						sortable: false,
					},
					{
						text: this.$t('fields.subscriptionCollected'),
						value: 'collected',
						type: '',
						allowFilter: false,
						sortable: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'delivery_type_id',
					descending: true,
				},
			},
		};
	},
	watch: {
		'subscription.date': {
			handler: function (newVal) {
				if (newVal != null && this.subscription.magazine_id != null) {
					this.reloadSubscriptionRecipientsData(this.subscriptionRecipientsTable.lastRequest);
				}
			},
			deep: true,
		},
		'subscription.magazine_id': {
			handler: function (newVal) {
				if (newVal != null && this.subscription.date != null) {
					this.reloadSubscriptionRecipientsData(this.subscriptionRecipientsTable.lastRequest);
				}
			},
			deep: true,
		},
	},
	methods: {
		getData() {
			let vm = this;
			this.$APICall('get', 'subscriptions/' + this.subscription.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.subscription = usableData;
					vm.$nextTick(() => {
						vm.initialLoad = true;
						vm.$myStore.commit('setBreadcrumbs', [
							{
								text: vm.$t('modules.subscriptions'),
								href: '/#/subscriptions',
								disabled: false,
							},
							{
								text: vm.subscription.date,
								href: '/#/subscriptions/' + vm.subscription.id,
								disabled: true,
							},
						]);
					});
				} else {
					this.$myStore.commit('setBreadcrumbs', [
						{ text: this.$t('modules.subscriptions'), href: '/#/subscriptions', disabled: false },
					]);
				}
			});
		},
		selectSubscriptionRecipientsHeaders(headers) {
			this.subscriptionRecipientsTable.selectedHeaders = headers;
		},
		reloadSubscriptionRecipientsData(request) {
			if (request == null) {
				request = {
					pagination: {
						sortDesc: true,
						page: 1,
						itemsPerPage: 50,
						sortBy: ['member_display'],
						totalItems: 0,
					},
					search: {},
				};
			}
			this.subscriptionRecipientsTable.lastRequest = request;
			request.id = this.subscription.id;
			request.date = this.subscription.date;
			request.magazine_id = this.subscription.magazine_id;
			let vm = this;
			this.$APICall(
				'get',
				'subscription-recipients/' + this.subscription.id,
				request,
				(data, success) => {
					if (success) {
						vm.subscriptionRecipientsTable.items = data.items;
						vm.subscriptionRecipientsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.subscriptionRecipientsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'subscription-recipients/' + this.subscription.id,
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/subscription-recipients', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolveSubscriptionRecipientsWindowResize() {
			this.subscriptionRecipientsTable.height = window.innerHeight - 330 + 'px';
		},
		backClick() {
			this.$router.replace('/subscriptions');
		},
		saveClick() {
			let vm = this;
			let success = true;
			if (this.subscription.date == null) {
				this.subscriptionValidation.date = false;
				success = false;
			} else {
				this.subscriptionValidation.date = true;
			}
			if (this.subscription.magazine_id == null) {
				this.subscriptionValidation.magazine_id = false;
				success = false;
			} else {
				this.subscriptionValidation.magazine_id = true;
			}
			if (success) {
				this.$APICall(
					'post',
					'subscriptions',
					this.subscription,
					(data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.basicAdd'));
							vm.backClick();
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					},
					true
				);
			}
		},
		toggleCollected(item){
			if(this.subscription.id != 0){
				item.collected = !item.collected;
				this.$APICall('post','subscriptions-toggle-collected',{id: item.id},(data, success) => {});
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.subscriptions'), href: '/#/subscriptions', disabled: false },
		]);
		if (this.subscription.id != 0) {
			this.getData();
		} else {
			this.inEditMode = true;
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.subscriptions'),
					href: '/#/subscriptions',
					disabled: false,
				},
				{
					text: 'Nova pretplata',
					href: '/#/subscriptions/' + this.subscription.id,
					disabled: true,
				},
			]);
		}
		window.addEventListener('resize', this.resolveSubscriptionRecipientsWindowResize);
		this.resolveSubscriptionRecipientsWindowResize();
	},
};
</script>

<style scoped></style>
